import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d5a341ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d5a341ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a341ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/研訊/shopstore_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5a341ac')) {
      api.createRecord('d5a341ac', component.options)
    } else {
      api.reload('d5a341ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d5a341ac&scoped=true&", function () {
      api.rerender('d5a341ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Kanban/index.vue"
export default component.exports